import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

const AgencyNav = (props) => {
  const location = useLocation();
  const isOperationPage =
    location.pathname === "/agency/AgencyPolygonCreation" ||
    location.pathname === "/agency/agencyoperationstatus";
  const operationStyle = isOperationPage
    ? { textDecoration: "underline  5px", textUnderlineOffset: "8px" }
    : { textDecoration: "none" };
  return (
    <div>
      <Nav
        className="navbar navbar-expand navbar-dark "
        style={{
          height:"6.75vh",
          backgroundColor:
            "linear-gradient(90.27deg, #023E8A 0.23%, #0096C7 99.42%)",
          backgroundImage:
            "linear-gradient(90.27deg, #023E8A 0.23%, #0096C7 99.42%)",
  
          padding: "0.7rem 2rem",
          position: "relative",
        }}
      >
        <Link to={"/home"} className=" logo-text">
          <img
            src={props.logo_dronewhite}
            alt="profile-img"
            style={{
              margin: "10px",
              height: "60px",
              filter: "invert(1) grayscale(1) brightness(2)",
            }}
          />
        </Link>
        &nbsp;&nbsp;
        <div className="navbar-nav">
          <div className="navbar-nav ml-auto">
            <NavDropdown
              show={props.showOperation}
              onMouseEnter={props.showDropdownOperation}
              onMouseLeave={props.hideDropdownOperation}
              title={
                <div
                  //className="navbar-nav ml-auto"
                  style={{
                    color: "#ffffff",

                    //position: "absolute",
                  }}
                >
                  <li className="nav-item activenav" style={operationStyle}>Operation</li>{" "}
                </div>
              }
              className="nav-dropdown"
              style={{
                color: "red",

                fontFamily: "Montserrat",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "26px",
                lineHeight: "32px",
                //left: "200px",
                transform: "none",
                marginTop: "7px",
                top: "0px",
              }}
            >
              <NavDropdown.Item
                eventKey="4.3"
                href="/agency/AgencyPolygonCreation"
              >
                ขออนุญาตขึ้นบินโดรน
              </NavDropdown.Item>
              <NavDropdown.Item
                eventKey="4.4"
                href="/agency/agencyoperationstatus"
              >
                สถานะการขออนุญาต
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
        {props.currentUser ? (
          <div className="navbar-nav ml-auto">
            <NavDropdown
              show={props.showProfile}
              onMouseEnter={props.showDropdownProfile}
              onMouseLeave={props.hideDropdownProfile}
              title={
                <div style={{ display: "flex" }}>
                  <div
                    className="navbar-nav ml-auto"
                    style={{
                      color: "#ffffff",
                      right: "30%",
                      //position: "absolute",
                      top: "-5px",
                      fontSize: "26px",
                      lineHeight: "32px",
                      fontWeight: "400",
                      fontStyle: "normal",
                    }}
                  >
                    <li className="nav-item activenav">
                      {props.currentUser.f_name.substring(0, 8)}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                    </li>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ left: "100%" }}>
                      <div
                        className="navbar-nav ml-auto"
                        style={{
                          position: "absolute",
                          top: "10%",
                          //left: "6%",
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#023E8A",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "26px",
                          color: "white",
                          borderRadius: "50%",
                        }}
                      >
                        {props.currentUser.f_name.charAt(0)}
                      </div>
                    </div>
                  </div>
                </div>
              }
              className="nav-dropdown"
              style={{
                color: "#EDEDED",
                fontFamily: "Kanit",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "34px",
                //top: "18px",
                //left: "1670px",
                //position: "absolute",
                right: "25%",
                width: "100%",
              }}
            >
              <NavDropdown.Item eventKey="4.1" onClick={() => props.logOut()}>
                ออกจากระบบ
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        ) : (
          <div className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link
                to={"/login"}
                className="nav-link"
                style={{ color: "white" }}
              >
                Login
              </Link>
            </li>

            <li className="nav-item">
              <Link
                to={"/register"}
                className="nav-link"
                style={{ color: "white" }}
              >
                Sign Up
              </Link>
            </li>
          </div>
        )}
      </Nav>
    </div>
  );
};

export default AgencyNav;
